import { format } from "prettier";
import {APP_KEY, HTTP_URL, PHP_API_URL} from "../../../util/constants";
import request from "../../../util/request";
import Cookies from 'js-cookie';
// 获取资源库列表接口
export function getInfoListRequest(nameKey,status,offset,limit, callback) {
    let formData = new FormData();
    formData.append('appkey', "spark");
    formData.append('user_token', Cookies.get("userToken"));
    formData.append('caozuo', "admin_get_ziyuan_list");
    formData.append('namekey', nameKey);
    formData.append('status', status);
    formData.append('offset', offset);
    formData.append('limit', limit);
    return request(
        PHP_API_URL+'/Jiaoxue_ziyuan/i',
        {
            method: 'POST',
            body: formData
        },
        callback
    );
}

export function changeZiyuanStatusRequest(ziyuan_code,status, callback) {
    let formData = new FormData();
    formData.append('appkey', "spark");
    formData.append('user_token', Cookies.get("userToken"));
    formData.append('caozuo', "change_ziyuan_status");
    formData.append('ziyuan_code', ziyuan_code);
    formData.append('status', status);
    return request(
        PHP_API_URL+'/Jiaoxue_ziyuan/i',
        {
            method: 'POST',
            body: formData
        },
        callback
    );
}
export function addZiyuanRequest(ziyuan_name,des,ziyuan_url,jifen,fengmian_link,grade_code_str,subject_code_str,detail_link,size, callback) {
    let formData = new FormData();
    formData.append('appkey', "spark");
    formData.append('user_token', Cookies.get("userToken"));
    formData.append('caozuo', "admin_add_ziyuan");
    formData.append("username",Cookies.get("username"));
    formData.append("ziyuan_name",ziyuan_name);
    formData.append("des",des);
    formData.append("ziyuan_url",ziyuan_url);
    formData.append("jifen",jifen);
    formData.append("fengmian_link",fengmian_link);
    formData.append("grade_code_str",grade_code_str);
    formData.append("subject_code_str",subject_code_str);
    formData.append("detail_link",detail_link);
    formData.append("size",size);
    return request(
        PHP_API_URL+'/Jiaoxue_ziyuan/i',
        {
            method: 'POST',
            body: formData
        },
        callback
    );
}
export function edtZiyuanRequest( status,ziyuan_code,ziyuan_name,des,ziyuan_url,jifen,fengmian_link,grade_code_str,subject_code_str,detail_link,size, callback) {
    let formData = new FormData();
    formData.append('appkey', "spark");
    formData.append('user_token', Cookies.get("userToken"));
    formData.append('caozuo', "admin_edit_ziyuan");
    formData.append("username",Cookies.get("username"));
    formData.append('status', status);
    formData.append("ziyuan_code",ziyuan_code);
    formData.append("ziyuan_name",ziyuan_name);
    formData.append("des",des);
    formData.append("ziyuan_url",ziyuan_url);
    formData.append("jifen",jifen);
    formData.append("fengmian_link",fengmian_link);
    formData.append("grade_code_str",grade_code_str);
    formData.append("subject_code_str",subject_code_str);
    formData.append("detail_link",detail_link);
    formData.append("size",size);
    return request(
        PHP_API_URL+'/Jiaoxue_ziyuan/i',
        {
            method: 'POST',
            body: formData
        },
        callback
    );
}
export function getAliOssTokenRequest(callback) {
  let formData = new FormData()
  formData.append('appkey', 'spark')
  formData.append('utoken', Cookies.get("userToken"))
  return request(
    PHP_API_URL + '/aliyun/osssts.php',
    {
      method: 'POST',
      body: formData,
    },
    callback,
  )
}


//获取学科列表
export function getXuekeListRequest(
    username,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append("caozuo",'get_nianji_xueke_list');
  formData.append("username",username);

  return request(PHP_API_URL+'/index.php/School/i', {
    method: "POST",
    body: formData,
  }, callback);
}


//获取学科列表
export function uploadDetailFileRequest(
    file,
    callback) {
  let formData = new FormData();
  formData.append("appkey",APP_KEY);
  formData.append('user_token', Cookies.get("userToken"));
  formData.append("caozuo",'upload_detail_file');
  formData.append("file_name", file.name.replace(/\.[^/.]+$/, ''));
  formData.append("file", file);

  return request(PHP_API_URL+'/Jiaoxue_ziyuan/i', {
    method: "POST",
    body: formData,
  }, callback);
}